/**
 * Ryan O'Dowd
 * 2024-09-22
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Container from './Container';
import Content from './Content';
import Header from './Header';

const WidgetBase = {
  Container,
  Content,
  Header,
};

export default WidgetBase;
